import { Modal } from "ui/Modal"
import { useTranslation } from "react-i18next"
import { Button, Flex } from "antd"
import { Text, Title } from "ui/Typography"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import PropTypes from "prop-types"
import { spacings } from "themes/variables"

const DisconnectConfirmation = ({ onOpen, onClose, handleDisconnect, provider }) => {
  const { t } = useTranslation()
  return (
    <Modal
      width={430}
      centered
      title={
        <Flex justify="center" align="center">
          <WarningOutlinedWithBg />
        </Flex>
      }
      open={onOpen}
      onCancel={onClose}
    >
      <Flex vertical gap={spacings.XL}>
        <Flex vertical gap={spacings.M} className="pb-xs">
          <Title level={3}>{t("login_security.disconnect_account")}</Title>
          <Text>{t("login_security.disconnect_confirmation", { provider })}</Text>
        </Flex>
        <Flex gap={spacings.S}>
          <Button variant="outlined" color="primary" className="p-l" onClick={onClose}>
            {t("global.cancel")}
          </Button>
          <Button type="primary" danger onClick={handleDisconnect} className="p-l">
            {t("global.disconnect")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

DisconnectConfirmation.propTypes = {
  onOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleDisconnect: PropTypes.func.isRequired,
  provider: PropTypes.string.isRequired
}

export default DisconnectConfirmation
